export default __webpack_public_path__ + "static/media/asusLogo.317de9f1.svg";